import { Star, ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../constants/business";

export const Reviews = () => (
  <section id="reviews" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#0A0A0A]" data-testid="reviews-section">
    <div className="max-w-3xl">
      <Reveal>
        <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">06 — Reviews</p>
        <div className="flex gap-1 mb-6" aria-hidden="true">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-5 h-5 text-[#FF3B30] fill-[#FF3B30]" />
          ))}
        </div>
        <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="reviews-heading">
          Don't Take Our Word.<br /><span className="text-zinc-500">Take Theirs.</span>
        </h2>
        <p className="mt-6 text-zinc-400 text-base md:text-lg">
          Read what real customers say about our work on Google — unedited and straight from them.
        </p>
        <a
          href={BUSINESS.mapsListing}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="read-reviews-btn"
          className="mt-10 inline-flex items-center gap-3 border border-zinc-500 text-white font-oswald uppercase tracking-[0.15em] px-10 py-4 hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none"
        >
          Read Our Reviews <ExternalLink className="w-4 h-4" />
        </a>
      </Reveal>
    </div>
  </section>
);
